// composables/useApi.ts
import { type UseFetchOptions } from 'nuxt/app'
import defu from 'defu'

import { encrypt_bson } from '~/utils/secure_messaging'
import { getDevMockResponse, getDevMockScenario } from '~/utils/devMock'

// const toast = useToast()



export const useApi = () => {
  const config = useRuntimeConfig()
  // const token = import.meta.client ? localStorage.getItem('token') : null

  const auth_store = useAuthStore()

  // В dev при заданном DEV_PROXY_TARGET ходим на свой origin — запросы к /api
  // проксируются nitro-девсервером на стенд (см. nitro.devProxy в nuxt.config.ts)
  const base_url = import.meta.dev && config.public.dev_proxy_target
    ? ''
    : (config.public.api_url || 'https://scb-wl-api.revio.vip')


  const fetchWrapper = async <R>(endpoint: string, options: UseFetchOptions<any> = {}) => {
	if (getDevMockScenario()) {
		return getDevMockResponse(endpoint, options.body) as R
	}

    // Базовые опции для всех запросов
    const defaults: UseFetchOptions<R> = {
      // baseURL: config.public.api_url || 'https://ptp-api.netwood.site',
      baseURL: base_url,
      // Добавляем обработку ошибок
      onResponseError: async ({ response }) => {
        if ((response.status === 401 || response.status === 403) &&
          endpoint !== '/api/hybrid/create_session' && endpoint !== '/api/hybrid/tma_login' &&
          !(endpoint === '/api/hybrid/get_user' && auth_store.status === 'loading')) {
          await auth_store.create_session()
        }
      }
    }

    // Настраиваем заголовки в зависимости от окружения
    // if (import.meta.dev && import.meta.client && cookie.value) {
    //   // Для локальной разработки используем Authorization header
    //   defaults.headers = {
    //     ...options.headers,
    //     'Authorization': `Bearer ${cookie.value}`
    //   }
    // } 

    defaults.headers = {
      ...options.headers,
      'Authorization': `Bearer ${auth_store.session_token}`
    }
    
    // else {
    //   // Для production используем куки
    //   defaults.credentials = 'include'
    // }

    // Объединяем дефолтные опции с переданными
    const finalOptions: UseFetchOptions<R> = defu(options, defaults)

    return $fetch<R>(endpoint, finalOptions as any)
  }

  return {
    // GET запрос
    get: <T>(endpoint: string, data: any = {},  options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, { ...options, method: 'GET', query: data })
    },

    // POST запрос
    post: <T>(endpoint: string, data: any = {}, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: data
      })
    },

    post_form: <T>(endpoint: string, form_data: any = {}, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: form_data
      })
    },

    post_secure: async <T>(endpoint: string, data: any = {}, options: UseFetchOptions<T> = {}) => {

      const otk_response = await fetchWrapper('/api/secure/otk', { ...options, method: 'POST' })

      // console.log('otk_response',otk_response)

      const body = {
        data: await encrypt_bson(otk_response.public_key, data),
        uuid: otk_response.uuid
      }

      // console.log('body',body)

      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'POST',
        body: body,
      })
    },

    // PUT запрос
    put: <T>(endpoint: string, data: any, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, {
        ...options,
        method: 'PUT',
        body: data
      })
    },

    // DELETE запрос
    delete: <T>(endpoint: string, options: UseFetchOptions<T> = {}) => {
      return fetchWrapper<T>(endpoint, { ...options, method: 'DELETE' })
    },

    get_receipt_image_url: (file_name: string) => {
      return `${base_url}/api/client/fg/receipt_image/${file_name}`
    }
  }

  
}
